import React from 'react';
import { connect } from 'react-redux';

import MenuItemChoiceSelection from '../../common/menuitem/MenuItemChoiceSelection';
import SpecialItemSubmitButton from './SpecialItemSubmitButton';

import { cartItemLoadSpecialItems } from '../../../actions/cartItem';
import generateSpecialPrice from '../../../utils/generateSpecialPrice';

import { setSpecialPanel } from '../../../actions/panels';

class ViewCustomPizzaToppings extends React.Component {

    updateTopping(topping_id) {

        const updatedSpecialItems = this.props.cartItem.items.map((theCartItem, theIndex) => {
            if (this.props.index == theIndex) {

                if(theCartItem.toppings.find((theTopping) => theTopping.id == topping_id)) {

                    theCartItem.toppings = theCartItem.toppings.filter((theTopping) => theTopping.id != topping_id);
                }
                else {
            
                    // it's not found; add it if we haven't reached the top amount of max toppings
                    if (theCartItem.toppings.length < theCartItem.max_toppings) {
                        theCartItem.toppings = theCartItem.toppings.concat({
                            id: topping_id,
                            amount: "include",
                            portion: "W",
                        });
                    }              
                }
            }

            return theCartItem;
        });

        this.props.dispatch(cartItemLoadSpecialItems(updatedSpecialItems));
    }

    updatePortion(topping_id) {

        const updatedSpecialItems = this.props.cartItem.items.map((theCartItem, theIndex) => {
            if (this.props.index == theIndex) {

                this.props.cartItem.items[this.props.index].toppings.forEach((theCartTopping, index) => {
                    if (theCartTopping.id == topping_id) {
                        isInToppingsList = true;
                        newAmount = "";
            
                        if (theCartTopping.portion == "W") {
                            theCartItem.toppings[index].portion = "H1";
                        }
                        else if (theCartTopping.portion == "H1") {
                            theCartItem.toppings[index].portion = "H2";
                        }
                        else {
                            theCartItem.toppings[index].portion = "W";
                        }
                    }
                });
            }

            return theCartItem;
        });

        this.props.dispatch(cartItemLoadSpecialItems(updatedSpecialItems));
    }

    render() {

        return (
            <div>
                <div className="menu-item-window menu-item-list">
                    {this.props.specialPizza.toppings.map((topping) => {
                        return (
                            <MenuItemChoiceSelection
                                isCustomPizza={true}
                                onChoicePress={() => { 
                                    this.updateTopping(topping.id);
                                }}
                                onPortionPress={() => {
                                    this.updatePortion(topping.id);
                                }}
                                cartToppings={this.props.cartItem.items[this.props.index].toppings}
                                topping={topping}
                                isToppingItem={true}
                            >
                                {topping.name}
                            </MenuItemChoiceSelection>
                        );
                    })}
                    <div className="fixed-wrapper-for-add-to-order">
                        <SpecialItemSubmitButton
                            onButtonPress={() => this.props.dispatch(setSpecialPanel('custom_pizza')) }
                            price={generateSpecialPrice(this.props.special, this.props.cartItem)}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        special: state.currentMenuItem.item,
        cartItem: state.cartItem
    };
};

export default connect(mapStateToProps)(ViewCustomPizzaToppings);
